import { render } from "./AccordionList.vue?vue&type=template&id=40ec8c4e"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__